import { z } from "zod";

export const BaseIdNameSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const BaseLabelValueValuesSchema = z.object(
  {
    label: z.string(),
    value: z.string(),
    values: z.array(z.string()),
  },
  {
    error: "Field required",
  }
);

export const BaseCreatorSchema = z.object({
  creator: z.union([z.string(), BaseIdNameSchema]),
  created: z.string(),
});

export const BaseUpdaterSchema = z.object({
  updater: z.union([z.string(), BaseIdNameSchema]),
  updated: z.string().optional(),
});

export const MoneySchema = z.object({
  value: z.number(),
  currency: z.string(),
});

// ------------------------------------------------------------------------------
// Types exported

export type BaseIdName = z.infer<typeof BaseIdNameSchema>;
export type Money = z.infer<typeof MoneySchema>;
